import React, { useState, useEffect, useContext } from 'react'
import { Box, Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Info } from '@material-ui/icons'
import { useTranslation, Trans } from 'react-i18next'
import { Context } from './../../../../Store'
import UploadReceipt from './../../../../steps/uploadReceipt'
import { getWithAuthentication } from './../../../../service/http'
import { sleep } from './../../../../utils/sleep'

export const BankTransferPaymentType = () => {
  const [error, setError] = useState()
  const [_, setDummyClearErrors] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [fundingInstruction, setFundingInstruction] = useState({})
  const [{ property, booking }] = useContext(Context)
  const { t } = useTranslation()

  const getData = async () => {
    try {
      setIsLoading(true)

      await getWithAuthentication(`${process.env.REACT_APP_API_GW_DALGONA_API}/user/create-customer-account`)
      // wait stripe customer id to be created in every services
      await sleep(500)

      getWithAuthentication(`${process.env.REACT_APP_API_GW_DALGONA_API}/user/funding-instructions`)
        .then((res) => {
          setIsLoading(false)
          setFundingInstruction(res.data)
        })
        .catch((error) => {
          setIsLoading(false)
          console.error(error)
        })
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Grid item xs={12} lg={11}>
        <Alert
          icon={<Info style={{ alignSelf: 'center' }} fontSize="inherit" />}
          severity="warning"
          style={{ color: '#FF7400', backgroundColor: '#FFC1011A' }}
        >
          <Trans
            i18nKey="booking.paymentInfo.transfer.alert"
            components={{
              1: <strong>{t('booking.paymentInfo.transfer.alertStrong')}</strong>,
            }}
          />
        </Alert>
      </Grid>
      {isLoading ? (
        <Grid item xs={12} lg={11}>
          <Card style={{ width: '100%', textAlign: 'center' }}>
            <CardContent>
              <CircularProgress />
            </CardContent>
          </Card>
        </Grid>
      ) : (
        <Grid item xs={12} lg={11}>
          <Card sx={{ minWidth: 275 }}>
            <CardContent>
              <Typography style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box fontWeight="fontWeightBold" fontSize="1rem">
                  {t('fundingInstruction.account')}
                </Box>
                <Box fontWeight="fontWeightRegular" fontSize="1rem">
                  {fundingInstruction?.account_holder_name}
                </Box>
              </Typography>
              <Typography style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box fontWeight="fontWeightBold" fontSize="1rem">
                  Bic
                </Box>
                <Box fontWeight="fontWeightRegular" fontSize="1rem">
                  {fundingInstruction?.bic}
                </Box>
              </Typography>
              <Typography style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box fontWeight="fontWeightBold" fontSize="1rem">
                  {t('fundingInstruction.nation')}
                </Box>
                <Box fontWeight="fontWeightRegular" fontSize="1rem">
                  {fundingInstruction?.country}
                </Box>
              </Typography>
              <Typography style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box fontWeight="fontWeightBold" fontSize="1rem">
                  IBAN
                </Box>
                <Box fontWeight="fontWeightRegular" fontSize="1rem">
                  {fundingInstruction?.iban}
                </Box>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      )}
      <Grid item xs={12} lg={11}>
        <Typography variant="body1">{t('booking.paymentInfo.transfer.uploadInputHeader')}</Typography>
        <UploadReceipt booking_id={booking.id} setError={setError} clearErrors={setDummyClearErrors} />
      </Grid>
    </>
  )
}
